import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="gradient-title">ABOUT US</h2>
          <div className="title-underline"></div>
        </div>
        
        <p className="about-description">
          At Genesis Sequence Solutions, we specialize in full-stack development and strategic consulting, 
          transforming low-code platforms into powerful business engines through expertly crafted solutions.
        </p>
        
        <div className="divider-line"></div>
        
        <div className="mission-vision">
          <div className="mission">
            <div className="icon-box">
              <span className="icon-text">M</span>
            </div>
            <h3>Our Mission</h3>
            <p>
              We transform low-code platforms into tailored business engines through expertly crafted 
              plugins and integrations. By automating workflows and enhancing user experiences, we help 
              businesses scale with confidence while maintaining integrity and innovation at our core.
            </p>
          </div>
          
          <div className="divider-line vertical"></div>
          
          <div className="vision">
            <div className="icon-box">
              <span className="icon-text">V</span>
            </div>
            <h3>Our Vision</h3>
            <p>
              We envision a future where every organization harnesses low-code excellence to innovate 
              and delight customers. Through global platform scaling and investment in South African 
              tech talent, we're building a more efficient and connected digital ecosystem.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;